import cn from "classnames";
import styles from "./Typo.module.scss";

export interface TypoProps {
  className?: string;
  children?: React.ReactNode;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'p' | 'div' | 'span';
  color?: 'primary' | 'grey-700' | 'grey-800' | 'black' | 'error' | 'error-bright' | 'error-sade' | 'success' | 'sade-black' | 'yellow-sade';
  weight?: 'regular' | 'medium' | 'semiBold' | 'bold' | 'extraBold';
  dangerouslySetInnerHTML?: {
    __html: string | TrustedHTML;
  };
  ellipsis?: boolean;
  lines?: number;
  width?: number;
  maxWidth?: string;
}

const Tag = ({
  className,
  children,
  as,
  color,
  weight,
  dangerouslySetInnerHTML,
  ellipsis,
  lines,
  width,
  maxWidth,
}: TypoProps) => {
  const TextTag = (as ?? 'span') as keyof JSX.IntrinsicElements;
  return (
    <TextTag
      className={cn(
        styles.typo,
        color && styles[`color-${color}`],
        ellipsis && styles.ellipsis,
        ellipsis && lines && (lines > 1) && styles.multiline,
        weight && styles[`weight-${weight}`],
        className,
      )}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
      style={{
        maxWidth,
        width,
        WebkitLineClamp: lines ?? "",
      }}
    >
      {children}
    </TextTag>
  )
}

// не влияет на размер, но позволяет указать цвет и обрезку текста
export const Text = (props: TypoProps) => {
  return (
    <Tag
      {...props}
      as={props.as}
      className={cn(props.className)}
    />
  );
};

export const H1 = (props: TypoProps) => {
  return (
    <Tag
      {...props}
      as={props.as ?? 'h1'}
      className={cn(props.className, styles.h1)}
    />
  );
};

export const H2 = (props: TypoProps) => {
  return (
    <Tag
      {...props}
      as={props.as ?? 'h2'}
      className={cn(props.className, styles.h2)}
    />
  );
};

export const H3 = (props: TypoProps) => {
  return (
    <Tag
      {...props}
      as={props.as ?? 'h3'}
      className={cn(props.className, styles.h3)}
    />
  );
};

export const H4 = (props: TypoProps) => {
  return (
    <Tag
      {...props}
      as={props.as ?? 'h4'}
      className={cn(props.className, styles.h4)}
    />
  );
};

export const P1 = (props: TypoProps) => {
  return (
    <Tag
      {...props}
      as={props.as ?? 'p'}
      className={cn(props.className, styles.p1)}
    />
  );
};

export const P2 = (props: TypoProps) => {
  return (
    <Tag
      {...props}
      as={props.as ?? 'p'}
      className={cn(props.className, styles.p2)}
    />
  );
};

export const P3 = (props: TypoProps) => {
  return (
    <Tag
      {...props}
      as={props.as ?? 'p'}
      className={cn(props.className, styles.p3)}
    />
  );
};

export const Title1 = (props: TypoProps) => {
  return (
    <Tag
      {...props}
      as={props.as ?? 'span'}
      className={cn(props.className, styles.title3)}
    />
  );
};

export const Title2 = (props: TypoProps) => {
  return (
    <Tag
      {...props}
      as={props.as ?? 'span'}
      className={cn(props.className, styles.title2)}
    />
  );
};

export const Title3 = (props: TypoProps) => {
  return (
    <Tag
      {...props}
      as={props.as ?? 'span'}
      className={cn(props.className, styles.title3)}
    />
  );
};

export const SubTitle1 = (props: TypoProps) => {
  return (
    <Tag
      {...props}
      as={props.as ?? 'span'}
      className={cn(props.className, styles.subtitle1)}
    />
  );
};

export const SubTitle2 = (props: TypoProps) => {
  return (
    <Tag
      {...props}
      as={props.as ?? 'span'}
      className={cn(props.className, styles.subtitle2)}
    />
  );
};

export const SubTitle3 = (props: TypoProps) => {
  return (
    <Tag
      {...props}
      as={props.as ?? 'span'}
      className={cn(props.className, styles.subtitle3)}
    />
  );
};

export const Label = (props: TypoProps) => {
  return (
    <Tag
      {...props}
      as={props.as ?? 'span'}
      className={cn(props.className, styles.label)}
    />
  );
};
